import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Search, Layers, Calculator, Target } from 'lucide-react';
const benefits = [{
  icon: Search,
  title: 'A Caça aos Vazamentos Invisíveis',
  description: 'Como encontrar seus primeiros R$ 500 perdidos em assinaturas e taxas fantasmas.'
}, {
  icon: Layers,
  title: 'O Sistema das 3 Cubetas',
  description: 'A forma automática de separar seu dinheiro para Vida, Paz e Lazer. Gaste sem culpa.'
}, {
  icon: Calculator,
  title: "A Calculadora de 'Horas de Vida'",
  description: 'O truque psicológico que interrompe 50% das suas compras por impulso.'
}, {
  icon: Target,
  title: 'Protocolo Saca-Dívidas',
  description: 'O plano de ataque passo a passo para ver suas faturas no cartão em R$ 0.'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function BenefitsSection() {
  return <section className="bg-gray-light py-20 px-6" data-id="element-9">
      <div className="max-w-6xl mx-auto" data-id="element-10">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-11">
          <h2 className="font-heading font-bold text-navy text-3xl md:text-4xl" data-id="element-12">
            O que você recebe por apenas R$ 34,90?
          </h2>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-13">
          {benefits.map((benefit, index) => {
          const Icon = benefit.icon;
          return <motion.div key={index} variants={itemVariants} className="bg-white p-8 rounded-2xl shadow-sm hover:shadow-md transition-shadow duration-300 border border-gray-100 flex flex-col sm:flex-row gap-6 items-start" data-id="element-14">
                <div className="bg-orange/10 p-4 rounded-xl shrink-0" data-id="element-15">
                  <Icon className="w-8 h-8 text-orange" data-id="element-16" />
                </div>
                <div data-id="element-17">
                  <h3 className="font-heading font-bold text-navy text-xl mb-3" data-id="element-18">
                    {benefit.title}
                  </h3>
                  <p className="font-body text-navy/80 leading-relaxed" data-id="element-19">
                    {benefit.description}
                  </p>
                </div>
              </motion.div>;
        })}
        </motion.div>
      </div>
    </section>;
}